import { Routes } from "@angular/router";
import { AuthGuardService } from "./guards/auth-guard.service";
import { sentEmailsGuard } from "./modules/sent-emails/sent-emails.guard";

export const appRoutes: Routes = [
	{
		path: "encounters",
		data: { helpContext: "encounters" },
		loadChildren: () => import("./modules/encounters/encounters.module").then((m) => m.EncountersModule),
	},
	{
		path: "education",
		data: { helpContext: "education" },
		loadChildren: () => import("./modules/education/education.module").then((m) => m.EducationModule),
	},
	{
		path: "my-protocols",
		canActivate: [AuthGuardService],
		data: { helpContext: "protocols.list", preload: true },
		loadComponent: () =>
			import("./modules/protocols/my-protocols/my-protocols.component").then((m) => m.MyProtocolsComponent),
	},
	{
		path: "protocols",
		data: { helpContext: "protocols", preload: true },
		loadChildren: () => import("./modules/protocols/protocols.module").then((m) => m.ProtocolsModule),
	},
	{
		path: "pathways",
		data: { helpContext: "pathways" },
		loadChildren: () => import("./modules/pathways/pathways.module").then((m) => m.PathwaysModule),
	},
	{
		path: "patients",
		data: { helpContext: "patients" },
		loadChildren: () => import("./modules/patients/patients.module").then((m) => m.PatientsModule),
	},
	{
		// Public: reached from the link emailed to the patient ({WEB_APP}/patient-portal#token=…).
		path: "patient-portal",
		loadChildren: () => import("./modules/patient-portal/patient-portal.module").then((m) => m.PatientPortalModule),
	},
	{
		path: "admin",
		loadChildren: () => import("./modules/supreme-admin/supreme-admin.module").then((m) => m.SupremeAdminModule),
	},
	{
		path: "institutes",
		data: { helpContext: "institutes" },
		loadChildren: () => import("./modules/institutes/institutes.module").then((m) => m.InstitutesModule),
	},
	{
		path: "directory",
		data: { helpContext: "directory" },
		loadChildren: () => import("./modules/directory/directory.module").then((m) => m.DirectoryModule),
	},
	{
		path: "videos",
		data: { helpContext: "videos", preload: true },
		loadChildren: () => import("./modules/videos/videos.module").then((m) => m.VideosModule),
	},
	{
		path: "quality",
		data: { helpContext: "quality" },
		loadChildren: () => import("./modules/quality/quality.module").then((m) => m.QualityModule),
	},
	{
		path: "tools",
		data: { helpContext: "tools" },
		loadChildren: () => import("./modules/tools/tools.module").then((m) => m.ToolsModule),
	},
	{
		path: "glasses",
		loadChildren: () => import("./modules/glasses/glasses.module").then((m) => m.GlassesModule),
	},
	{
		path: "users",
		data: { helpContext: "users" },
		loadChildren: () => import("./modules/users/users.module").then((m) => m.UsersModule),
	},
	{
		path: "formulas",
		data: { helpContext: "formulas" },
		loadChildren: () => import("./modules/formulas/formulas.module").then((m) => m.FormulasModule),
	},
	{
		path: "dashboard",
		loadChildren: () => import("./modules/dashboard/dashboard.module").then((m) => m.DashboardModule),
	},
	{
		path: "pharmacy",
		data: { helpContext: "pharmacy", preload: true },
		loadChildren: () => import("./modules/pharmacy/pharmacy.module").then((m) => m.PharmacyModule),
	},
	{
		path: "catalog",
		data: { helpContext: "catalog" },
		canActivate: [AuthGuardService],
		loadChildren: () => import("./modules/catalog/catalog.routes").then((m) => m.catalogRoutes),
	},
	{
		path: "remote-guidance",
		data: { helpContext: "remote-guidance" },
		canActivate: [AuthGuardService],
		loadChildren: () =>
			import("./modules/remote-guidance/remote-guidance.routes").then((m) => m.remoteGuidanceRoutes),
	},
	{
		path: "settings-user",
		data: { helpContext: "settings-user" },
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/users/settings-user/settings-user.component").then((m) => m.SettingsUserComponent),
	},
	{
		path: "sent-emails",
		canActivate: [AuthGuardService, sentEmailsGuard],
		loadComponent: () => import("./modules/sent-emails/sent-emails.component").then((m) => m.SentEmailsComponent),
	},
	{
		path: "help",
		canActivate: [AuthGuardService],
		loadChildren: () => import("./modules/help-center/help-center.routes").then((m) => m.helpCenterRoutes),
	},
	{
		path: "home",
		data: { helpContext: "home" },
		canActivate: [AuthGuardService],
		loadComponent: () => import("./modules/home/home.component").then((m) => m.HomeComponent),
	},
	{
		path: "statistics",
		data: { helpContext: "statistics" },
		loadChildren: () => import("./modules/statistics/statistics.module").then((m) => m.StatisticsModule),
	},
	{
		path: "misc",
		loadChildren: () => import("./modules/misc/misc.module").then((m) => m.MiscModule),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/snake",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/medical-snake/medical-snake.component").then((m) => m.MedicalSnakeComponent),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/triage",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/triage-rush/triage-rush.component").then((m) => m.TriageRushComponent),
	},
	{
		// Easter egg: unlocked by the secret key sequence on the tools dashboard.
		path: "games/invaders",
		canActivate: [AuthGuardService],
		loadComponent: () =>
			import("./modules/games/germ-invaders/germ-invaders.component").then((m) => m.GermInvadersComponent),
	},
	{
		path: "auth",
		loadComponent: () => import("./modules/auth/auth/auth.component").then((m) => m.AuthComponent),
	},
	{
		path: "",
		canActivate: [AuthGuardService],
		loadComponent: () => import("./modules/home/home.component").then((m) => m.HomeComponent),
	},
	{ path: "**", redirectTo: "protocols" },
];
